import { useCurrentUserQuery } from 'src/context/api/auth';

export const getTabs = (role: string | undefined) => {
    const tabs: any = {
        "/": [
            { title: "Workspaces list" }
        ],
        "/404": [
            { title: "404 Not Found" }
        ],
        "/workspaces": [
            { title: "Workspaces list" }
        ],
        "/admin/cockpit": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/users": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/users/add": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/admin/sso": [
            { title: "Administration", label: "Cockpit", path: "/admin/cockpit" },
            { title: "Administration", label: "Users", path: "/admin/users" },
            { title: "Administration", label: "SSO Integration", path: "/admin/sso", adminOnly: true },
        ],
        "/account": [
            { title: "Profile" },
        ],
        "/brand-overview": [
            { title: "Brand Overview" },
        ],
        "/competitors-monitoring": [
            { title: "Competitors Monitoring" },
        ],
        "/competitor-focus": [
            { title: "Competitors Focus" },
        ],
        "/text-ads": [
            { title: "Text Ads" },
        ],
        "/product-listing-ads": [
            { title: "Product Listing Ads" },
        ],
        "/brand-wayback": [
            { title: "Brand Wayback" },
        ],
        "/optimization/campaigns": [
            { title: "Campaigns" },
        ],
        "/optimization/overview": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/conversions-analysis": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/funnel": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/traffic-details": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],
        "/optimization/cluster-manager": [
            { title: "Performance", label: "Overview", path: "/optimization/overview" },
            { title: "Performance", label: "Funnel", path: "/optimization/funnel" },
            { title: "Performance", label: "Explore", path: "/optimization/traffic-details" },
            { title: "Performance", label: "Cluster Manager", path: "/optimization/cluster-manager" }
        ],

        "/optimization/activations/keywords/exact": [
            { title: "Activations", label: "Keywords (Exact)", path: "/optimization/activations/keywords/exact" },
            { title: "Activations", label: "Keywords (Other)", path: "/optimization/activations/keywords/other" },
            { title: "Activations", label: "Campaigns", path: "/optimization/activations/campaigns" },
        ],

        "/optimization/activations/keywords/other": [
            { title: "Activations", label: "Keyword (Exact)", path: "/optimization/activations/keywords/exact" },
            { title: "Activations", label: "Keyword (Other)", path: "/optimization/activations/keywords/other" },
            { title: "Activations", label: "Campaigns", path: "/optimization/activations/campaigns" },
        ],

        "/optimization/activations/campaigns": [
            { title: "Activations", label: "Keyword (Exact)", path: "/optimization/activations/keywords/exact" },
            { title: "Activations", label: "Keyword (Other)", path: "/optimization/activations/keywords/other" },
            { title: "Activations", label: "Campaigns", path: "/optimization/activations/campaigns" },
        ],

        "/visibility/overview": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/competition-evolution": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/st-analysis": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "/visibility/ads": [
            { title: "Visibility", label: "Overview", path: "/visibility/overview" },
            { title: "Visibility", label: "Competition Evolution", path: "/visibility/competition-evolution" },
            { title: "Visibility", label: "Search Term Analysis", path: "/visibility/st-analysis" },
            { title: "Visibility", label: "Ads", path: "/visibility/ads" },
        ],
        "regexp:^/workspaces/(?<id>[0-9]+)": [
            { title: "Administration" },
        ],
        "/non-branded/search-terms": [
            { title: "Search terms" },
        ],
        "/brand-pulse": [
            { title: "My Competitors", label: "Overview", path: "/brand-pulse/competitors" },
            { title: "My Competitors", label: "Competitors Selection", path: "/brand-pulse/competitors-selection" },
        ],
        "/non-branded/competitors": [
            { title: "Competitors" },
        ],
        "/non-branded/conquest-mode": [
            { title: "Conquest Mode" },
        ],
        "/leaderboard": [
            { title: "Leaderboard" },
        ]
    };

    if (role?.toLowerCase() !== "admin" && role?.toLowerCase() !== "brand specialist" && role?.toLowerCase() !== "consultant") {
        Object.keys(tabs).forEach((key) => {
            tabs[key] = tabs[key].filter((tab: any) => tab.label !== "Cluster Manager");
        });
    }

    if (role?.toLowerCase() !== "admin") {
        Object.keys(tabs).forEach((key) => {
            tabs[key] = tabs[key].filter((tab: any) => !tab.adminOnly);
        });
    }


    return tabs;
};
